import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom'; 
import styles from './UserEditForm.module.css'; 

const UserEditForm = () => {
  const { user_id } = useParams(); 
  const navigate = useNavigate();  
  
  const [user, setUser] = useState({ 
    name: '', 
    email: '', 
    phone_area_code: '', 
    phone_number: '' 
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        console.log(`Fetching user with ID: ${user_id}`); 
        const response = await axios.get(`http://localhost:5000/users/${user_id}`);
        console.log('Fetched user data:', response.data); 
        
        const { name, email, phone_area_code, phone_number } = response.data; 
        setUser({ 
          name, 
          email, 
          phone_area_code: phone_area_code || '', 
          phone_number: phone_number || '' 
        });
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };
    fetchUser();
  }, [user_id]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`http://localhost:5000/users/${user_id}`, user);
      navigate('/admin-panel'); 
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };
  
  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  return (
    <div className={styles.formContainer}>
      <h1>Edit User</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          name="name"
          value={user.name}
          onChange={handleChange}
          placeholder="Name"
        />
        <label htmlFor="name">Email:</label>
        <input
          type="email"
          name="email"
          value={user.email}
          onChange={handleChange}
          placeholder="Email"
        />
        <label htmlFor="name">Area Code:</label>
        <input
          type="text"
          name="phone_area_code"
          value={user.phone_area_code}
          onChange={handleChange}
          placeholder="Area Code"
          className={styles.phoneInput}
        />
        <label htmlFor="name">Phone Number:</label>
        <input
          type="text"
          name="phone_number"  
          value={user.phone_number}  
          onChange={handleChange}
          placeholder="Phone Number"
          className={styles.phoneInput}
        />
        <button type="submit">Update User</button>
      </form>
    </div>
  );
};

export default UserEditForm;
